var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.form.tagItem)?_c('div',[_c('crud-form',{attrs:{"schema":_vm.schema,"path":'tag-item-filters',"model":_vm.form,"form-title":_vm.$t('addFilter'),"redirect-route":'TagItemsFiltersList'}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }